export const FETCH_SIMILAR_MOVIES = 'FETCH_SIMILAR_MOVIES'
export const FETCH_SIMILAR_MOVIES_REQUEST = 'FETCH_SIMILAR_MOVIES_REQUEST'
export const FETCH_SIMILAR_MOVIES_SUCCESS = 'FETCH_SIMILAR_MOVIES_SUCCESS'